module.exports = __webpack_public_path__ + "c_static/img/3-1手机京东收藏夹.63fd5f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/3-1手机京东收藏夹.jpg
// module id = TCGC
// module chunks = 33